"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ForbiddenError = void 0;
const handled_error_1 = require("./handled.error");
class ForbiddenError extends handled_error_1.HandledError {
}
exports.ForbiddenError = ForbiddenError;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZm9yYmlkZGVuLmVycm9yLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2ZvcmJpZGRlbi5lcnJvci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxtREFBOEM7QUFFOUMsTUFBYSxjQUFlLFNBQVEsNEJBQVk7Q0FBRztBQUFuRCx3Q0FBbUQifQ==